// extracted by mini-css-extract-plugin
module.exports = {"header":"modalheader_header__OdyhZ","title":"modalheader_title__2a_aD","closeBtn":"modalheader_closeBtn__1hMQ5"};